<template>
  <div>
    <filtro
      :competencias-filtro="competencias"
      @update-competencias="atualizaCompetencias"
    ></filtro>
    <v-data-table
      class="elevation-5"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers"
      :items="faturas"
      :loading="isLoading"
      :pagination.sync="pagination"
      :total-items="totalFaturas"
      :rows-per-page-items="pageOptions"
      @update:pagination="gridExtratoDespesasFaturas"
    >
      <template v-slot:items="props">
        <td>{{ props.item.competencia }}</td>
        <td>{{ props.item.codigoFatura }}</td>
        <td>
          <v-btn
            flat
            small
            color="primary"
            @click="baixarExtratoDespesa(props.item.codigoFatura)"
            >Baixar</v-btn
          >
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";

import { createNamespacedHelpers } from "vuex";

import {
  baixarExtratoDespesa,
  buscaExtratoDespesasFatura
} from "@/services/beneficiario";
import { download } from "@/utils/download";
import { valorNumerico } from "@/utils/formataValores";

import Filtro from "./filtro";

const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "ExtratoDespesaGrid",
  components: {
    Filtro
  },
  props: {
    codigoBeneficiario: String
  },
  data() {
    return {
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      competencias: {
        inicio: moment()
          .subtract(1, "year")
          .format("YYYY-MM"),
        fim: moment().format("YYYY-MM")
      },
      faturas: [],
      isLoading: false,
      totalFaturas: 0,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        sortBy: "competencia",
        descending: true
      },
      headers: [
        { text: "Competência", value: "competencia" },
        { text: "Nº Fatura", value: "codigoFatura" },
        { text: "", value: "baixar" }
      ]
    };
  },
  watch: {
    codigoBeneficiario: {
      handler() {
        this.gridExtratoDespesasFaturas();
      }
    }
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    atualizaCompetencias(competencias) {
      this.competencias = { ...competencias };
      this.gridExtratoDespesasFaturas();
    },
    baixarExtratoDespesa(codigoFatura) {
      this.isLoading = true;

      baixarExtratoDespesa(this.codigoBeneficiario, codigoFatura)
        .then(({ headers, data }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          } else {
            const filename = headers["content-disposition"].replace(
              "attachment; filename=",
              ""
            );

            download(data, filename);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    gridExtratoDespesasFaturas() {
      this.isLoading = true;

      const { rowsPerPage, descending } = this.pagination;

      const competenciaInicio = valorNumerico(this.competencias?.inicio);
      const competenciaFim = valorNumerico(this.competencias?.fim);
      const page = this.pagination.page - 1;
      const size = rowsPerPage >= 1 ? rowsPerPage : 999;
      const sort = `competencia,${
        descending || descending === null ? "desc" : "asc"
      }`;

      return buscaExtratoDespesasFatura(
        this.codigoBeneficiario,
        competenciaInicio,
        competenciaFim,
        page,
        size,
        sort
      )
        .then(({ content, totalElements, data }) => {
          this.faturas = content;

          this.totalFaturas = totalElements;

          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
